import { Type } from "@angular/core";
import { Id } from "src/app/models/database/types/id.model";
import { DatafieldBooleanComponent } from "./datafield-boolean/datafield-boolean.component";
import { DatafieldChecklistComponent } from "./datafield-checklist/datafield-checklist.component";
import { DatafieldDateComponent } from "./datafield-date/datafield-date.component";
import { DatafieldHourComponent } from "./datafield-hour/datafield-hour.component";
import { DatafieldImageComponent } from "./datafield-image/datafield-image.component";
import { DatafieldNumberComponent } from "./datafield-number/datafield-number.component";
import { DatafieldRangeComponent } from "./datafield-range/datafield-range.component";
import { DatafieldTextComponent } from "./datafield-text/datafield-text.component";
import { DatafieldsEnum } from "./datafield.enum";

export class DatafieldComponentRelation {
    constructor(public component: Type<any>, public id: Id) { }
}

export class DatafieldComponentRelations extends Array<DatafieldComponentRelation> { }

export const datafieldComponentRelations: DatafieldComponentRelations = [
    new DatafieldComponentRelation(DatafieldTextComponent, DatafieldsEnum.TEXT),
    new DatafieldComponentRelation(DatafieldNumberComponent, DatafieldsEnum.NUMBER),
    new DatafieldComponentRelation(DatafieldBooleanComponent, DatafieldsEnum.BOOLEAN),
    new DatafieldComponentRelation(DatafieldChecklistComponent, DatafieldsEnum.CHECKLIST),
    new DatafieldComponentRelation(DatafieldDateComponent, DatafieldsEnum.DATE),
    new DatafieldComponentRelation(DatafieldHourComponent, DatafieldsEnum.HOUR),
    new DatafieldComponentRelation(DatafieldRangeComponent, DatafieldsEnum.RANGE),
    new DatafieldComponentRelation(DatafieldImageComponent, DatafieldsEnum.IMAGE)
]

export class DatafieldStringRelation {
    constructor(public id: Id, public type: string) { }
}
